import angular from "angular";
import module from "./module";
import { toArray } from "#/utils/enum";
import notificationSeverityEnum from "#/constants/notification-severity";

module.factory("NotificationsService", function($growlNotification, $window, $timeout, $interval) {
  "ngInject";
  var _timeout = 60000,
    _sticky = false;

  var stickyContainer = null;
  var checkInterval = null;
  var apiErrorElements = [];

  var factory = {
    success: function(insertBefore, title, text, onClose, sticky, timeout) {
      return show(
        notificationSeverityEnum.success.cssClass,
        insertBefore,
        title,
        text,
        onClose,
        sticky,
        timeout
      );
    },
    error: function(insertBefore, title, text, onClose, sticky, timeout) {
      return show(
        notificationSeverityEnum.error.cssClass,
        insertBefore,
        title,
        text,
        onClose,
        angular.isDefined(sticky) ? sticky : true,
        timeout
      );
    },
    warning: function(insertBefore, title, text, onClose, sticky, timeout) {
      return show(
        notificationSeverityEnum.warning.cssClass,
        insertBefore,
        title,
        text,
        onClose,
        angular.isDefined(sticky) ? sticky : true,
        timeout
      );
    },
    primary: function(insertBefore, title, text, onClose, sticky, timeout) {
      return show(
        notificationSeverityEnum.primary.cssClass,
        insertBefore,
        title,
        text,
        onClose,
        sticky,
        timeout
      );
    },
    info: function(insertBefore, title, text, onClose, sticky, timeout) {
      return show(
        notificationSeverityEnum.info.cssClass,
        insertBefore,
        title,
        text,
        onClose,
        sticky,
        timeout
      );
    },
    show: function(severity, insertBefore, title, text, onClose, sticky, timeout) {
      var obj = toArray(notificationSeverityEnum).find(_ => _.value === severity);
      if (obj !== null) {
        return factory[obj.text.toLowerCase()](insertBefore, title, text, onClose, sticky, timeout);
      } else {
        return factory.error(
          insertBefore,
          title,
          "Can't find severity=" + severity,
          onClose,
          sticky,
          timeout
        );
      }
    },
    apiError: function(insertBefore, title, message, onClose, sticky, timeout) {      
      var box = factory.error(insertBefore, title, message, onClose, sticky, timeout);
      
      $timeout(function() { trackApiErrorElement(insertBefore, title, message); }, 300);
      
      return box;
    }
  };
  
  function trackApiErrorElement(insertBefore, title, message) {
    function getDomElement(element) {
      if (!element) return null;
      
      if (element.nodeType) return element;
      
      if (element.length !== undefined && element[0]) {
        return element[0];
      }
      
      if (element.nativeElement) {
        return element.nativeElement;
      }
      
      return null;
    }
   
    var searchAreas = [
      getDomElement(insertBefore),
      document
    ];
   
    for (var areaIndex = 0; areaIndex < searchAreas.length; areaIndex++) {
      var searchArea = searchAreas[areaIndex];
      if (!searchArea || typeof searchArea.getElementsByClassName !== 'function') {
        continue;
      }
     
      var allNotifications = searchArea.getElementsByClassName('growl-notif-item-wrapper');
     
      for (var i = 0; i < allNotifications.length; i++) {
        var notification = allNotifications[i];
           
        if (notification.classList.contains('danger')) {
          var titleEl = notification.querySelector('b');
          var messageEl = notification.querySelector('p');
         
          var notificationTitle = titleEl ? titleEl.textContent.trim() : '';
          var notificationMessage = messageEl ? messageEl.textContent.trim() : '';
         
          if (notificationTitle === title && notificationMessage.indexOf(message.substring(0, 30)) !== -1) {
            if (apiErrorElements.indexOf(notification) === -1) {
              apiErrorElements.push(notification);
              return;
            }
          }
        }
      }
    }
  }
  
  function initStickySystem() {
    if (stickyContainer) return;
    
    var overlayDiv = document.createElement('div');
    overlayDiv.className = 'error-notifications-overlay';
    stickyContainer = angular.element(overlayDiv);
    document.body.appendChild(overlayDiv);
    
    if (!checkInterval) {
      checkInterval = $interval(function() {
        updateStickyNotifications();
      }, 250);
    }
  }
  
  function updateStickyNotifications() {
    while (stickyContainer[0].firstChild) {
      stickyContainer[0].removeChild(stickyContainer[0].firstChild);
    }
    
    apiErrorElements = apiErrorElements.filter(function(element) {
      return document.contains(element);
    });
    
    var overlayIndex = 0;
    
    for (var i = 0; i < apiErrorElements.length; i++) {
      var notification = apiErrorElements[i];
      
      if (notification.classList.contains('danger') && !isNotificationVisible(notification)) {
        createStickyOverlay(notification, overlayIndex, "danger");
        overlayIndex++;
      }
    }
  }
  
  function isNotificationVisible(element) {
    var rect = element.getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    
    return rect.bottom > 0 && rect.top < windowHeight;
  }
  
  function createStickyOverlay(originalNotification, index, cssClass) {
    var titleElement = originalNotification.querySelector('b');
    var messageElement = originalNotification.querySelector('p');
    
    var title = titleElement ? titleElement.textContent.trim() : 'Error';
    var message = messageElement ? messageElement.textContent.trim() : 'An error occurred';
    
    var overlayDiv = document.createElement('div');
    overlayDiv.className = 'overlay-notification ' + cssClass;
    overlayDiv.style.top = (index * 70 + 10) + 'px';
    
    var contentDiv = document.createElement('div');
    contentDiv.className = 'overlay-notification-content';
    
    var closeDiv = document.createElement('div');
    closeDiv.className = 'overlay-notification-close';
    closeDiv.textContent = '×';
    
    var textDiv = document.createElement('div');
    textDiv.className = 'overlay-notification-text';
    
    var titleStrong = document.createElement('strong');
    titleStrong.textContent = title;
    
    var messageDiv = document.createElement('div');
    messageDiv.textContent = message;
    
    textDiv.appendChild(titleStrong);
    textDiv.appendChild(messageDiv);
    contentDiv.appendChild(closeDiv);
    contentDiv.appendChild(textDiv);
    overlayDiv.appendChild(contentDiv);
    
    closeDiv.onclick = function() {
      var originalClose = originalNotification.querySelector('.growl-notif-close');
      if (originalClose) {
        originalClose.click();
      }
    };
    
    stickyContainer[0].appendChild(overlayDiv);
  }
    
  $timeout(function() {
    initStickySystem();
  }, 1000);
  
  var cleanupHandler = function() {
    if (checkInterval) {
      $interval.cancel(checkInterval);
    }
  };
  
  if (window.addEventListener) {
    window.addEventListener('beforeunload', cleanupHandler);
  }
  
  return factory;

  function show(cssClass, insertBefore, title, text, onClose, sticky, timeout) {
    var box = $growlNotification.box(insertBefore, title, text, {
      class: cssClass,
      sticky: angular.isDefined(sticky) ? sticky : _sticky,
      timeout: timeout || _timeout
    });
    if (onClose) {
      box.open().then(function() {
        onClose();
      });
    } else {
      box.open();
    }
    return box;
  }
});